"use strict";

exports.__esModule = true;
exports.default = void 0;

require("core-js/features/string/repeat");

// Polyfill
var pad = function pad(str, len) {
  if (len === void 0) {
    len = 2;
  }

  return ("" + '0'.repeat(len) + str).slice(-len);
};

var _default = pad;
exports.default = _default;